/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Image, Link } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'

// TODO Set the correct article ID here
const ARTICLE_ID = '00000000'

export function AppComponent() {
  return (
    <div className='index'>
      <ThemeSwitch />

      <div className='ui one column grid stackable'>
        <div className='column'>
          <div className='introBox'>
            <h4 className='graphicTitle'>Mehr als die Hälfte stammt aus Frankreich</h4>
            <div className='graphicSubtitle'>
            Anzahl Grenzgänger nach Herkunftsland und Arbeitskanton, 1. Quartal 2021
            </div>
          </div>
          <Image
            file={
              browserCheck.isMobile
                ? require('../../images/alluvial-diagram-grenzgaenger-mobile.svg')
                : require('../../images/alluvial-diagram-grenzgaenger.svg')
            }
            // file={require('../../images/pollenkalender.svg')}
            alt='flussdiagramm selbstests'
            className='cbImage selbsttests'
          />

          <div className='foot'>
            <p className='source'>Quelle: Bundesamt für Statistik / Grafik: pvo</p>
          </div>
        </div>
      </div>
    </div>
  )
}
